import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

export interface Product {
  item: string;
  price: number;
  category: string;
}

const PRODUCTS: Product[] = [
  { item: 'Líquido para fregar', price: 1, category: 'Limpieza' },
  { item: 'Torta de carne de vacuno (hamburguesa)', price: 7, category: 'Comida' },
  { item: 'Bandeja de filetes de pollo', price: 6.5, category: 'Comida' },
  { item: 'Carne picada de vacuno (1kg)', price: 6, category: 'Comida' },
  { item: 'Bolsa de arroz', price: 1.5, category: 'Comida' },
  { item: 'Hummus (pequeño)', price: 1.5, category: 'Comida' },
  { item: 'Natilla (peq)', price: 1.5, category: 'Comida' },
  { item: 'Pan de Hamburguesas', price: 1, category: 'Comida' },
  { item: 'Queso de sandwich (lonchas)', price: 1.5, category: 'Comida' },
  { item: 'Huevos (12)', price: 3, category: 'Comida' },
  { item: 'Bistec Plancha', price: 7.5, category: 'Comida' },
  { item: 'Fuet', price: 2, category: 'Comida' },
  { item: 'Pipas peladas', price: 1, category: 'Comida' },
  { item: 'Frutos secos mixtos', price: 3, category: 'Comida' },
  { item: 'Almendras', price: 2.5, category: 'Comida' },
  { item: 'Nueces', price: 3, category: 'Comida' },
  { item: 'Queso rallado', price: 1.5, category: 'Comida' },
  { item: 'Jugo de Naranja Natural (1L)', price: 3.5, category: 'Bebidas' },
  { item: 'Leche de SOJA (sabor vainilla)', price: 1.5, category: 'Bebidas' },
  { item: 'Salsa cesar', price: 1.5, category: 'Comida' },
  { item: 'Bolsa plastica', price: 0.15, category: 'Otros' },
  { item: 'Leche (1L)', price: 1, category: 'Bebidas' },
  { item: 'Miel de abeja', price: 3.5, category: 'Comida' },
  { item: 'Doritos Chips (nachos)', price: 2, category: 'Comida' },
  { item: 'Barras de cereal', price: 1.5, category: 'Comida' },
  { item: 'Agua (6L)', price: 1, category: 'Bebidas' },
  { item: 'Mayonesa', price: 2, category: 'Comida' },
  { item: 'Pasta Dental', price: 2, category: 'Higiene' },
  { item: 'Tortillas mexicanas (harina)', price: 1.5, category: 'Comida' },
  { item: 'Leche de Soja', price: 1, category: 'Bebidas' },
  { item: 'Caja de cereal', price: 2.5, category: 'Comida' },
  { item: 'Tomato (500Gr)', price: 1.5, category: 'Comida' },
  { item: 'Te para dormir', price: 1, category: 'Bebidas' },
  { item: 'Tallariines con queso (preparación rápida)', price: 1.5, category: 'Comida' },
  { item: 'Shampoo', price: 2, category: 'Higiene' },
  { item: 'Gel de ducha', price: 1.5, category: 'Higiene' },
  { item: 'Macarrones', price: 1.5, category: 'Comida' },
  { item: 'Salsa Cesar', price: 1.5, category: 'Comida' },
  { item: 'Bolsa de brotes (ensalada)', price: 2, category: 'Comida' },
  { item: 'Crotones', price: 1, category: 'Comida' },
  { item: 'Sabana (algodón y sintetica)', price: 13, category: 'Hogar' },
  { item: 'Funda almohada', price: 5, category: 'Hogar' },
  { item: '1Kg Carne de Vacuno', price: 6.5, category: 'Comida' },
  { item: 'Alcohol líquido', price: 0.75, category: 'Limpieza' },
  { item: 'Atún claro', price: 4.5, category: 'Comida' },
  { item: 'Fuet', price: 2.05, category: 'Comida' },
  { item: 'Arcos dentales', price: 1.8, category: 'Higiene' },
  { item: 'Palomitas Mantequilla', price: 1.15, category: 'Comida' },
  { item: 'Zumo Natural', price: 3.6, category: 'Bebidas' },
  { item: 'Pastacolgate total', price: 1.95, category: 'Higiene' },
  { item: 'Aplicadores oído', price: 0.8, category: 'Higiene' },
  { item: 'Agua', price: 1.5, category: 'Bebidas' },
  { item: 'Suavizante', price: 3.5, category: 'Limpieza' },
  { item: 'Multiusos Spray', price: 1.25, category: 'Limpieza' },
  { item: 'Ambientador', price: 1.1, category: 'Limpieza' },
  { item: 'Papel cocina', price: 3, category: 'Limpieza' },
  { item: 'Lentejas', price: 1.65, category: 'Comida' },
  { item: 'Jalapeños picantes', price: 1.55, category: 'Comida' },
  { item: 'Flan vainilla (6)', price: 0.8, category: 'Comida' },
  { item: 'Tomate concentrado', price: 0.85, category: 'Comida' },
  { item: 'Salami paquete (4)', price: 1.45, category: 'Comida' },
  { item: '1L Leche SOJA', price: 0.8, category: 'Bebidas' }
];


@Component({
  selector: 'app-supermarket-helper',
  templateUrl: './supermarket-helper.component.html',
  styleUrls: ['./supermarket-helper.component.css']
})
export class SupermarketHelperComponent implements OnInit {

  displayedColumns: string[] = ['select', 'item', 'price', 'category'];
  displayedColumnsCart: string[] = ['item', 'price'];
  dataSource = new MatTableDataSource(PRODUCTS);
  selection = new SelectionModel<Product>(true, []);
  searchControl = new FormControl('');

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.searchControl.valueChanges.subscribe(value => {
      this.applyFilter(value);
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  get totalPrice() {
    return this.selection.selected.reduce((acc, item) => acc + item.price, 0);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected === numRows;
  }

  isIndeterminate() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected > 0 && numSelected < numRows;
  }

  masterToggle(isChecked: boolean) {
    if (isChecked) {
      this.selection.select(...this.dataSource.filteredData);
    } else {
      this.selection.clear();
    }
  }

  toggleSelection(element: Product) {
    this.selection.toggle(element);
  }
}